import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigationBreadCrumb } from 'store/navigation/actions';
import { navigationBreadCrumbSelector } from 'store/navigation/selectors';

// Usage: simply call the hook by itself and pass in the string that you would like the final breadcrumb to
// be. Do not place in a useEffect as the hook mainatins it's own useEffect and will properly clear the
// bread crumb when it unmounts.

// Replaces the last breadcrumb handled by navigation which is
// usually just the component name being rendered. This allows
// for a custom breadcrumb to be used at the end of the current
// state of the bread crumb component.
const useUpdateBreadCrumb = (breadCrumb: string) => {
  const dispatch = useDispatch();
  const currentBreadCrumb = useSelector(navigationBreadCrumbSelector);
  useEffect(() => {
    if (currentBreadCrumb !== breadCrumb) {
      dispatch(navigationBreadCrumb(breadCrumb));
    }

    return () => {
      dispatch(navigationBreadCrumb(''));
    };
  }, [breadCrumb]);
};

export default useUpdateBreadCrumb;
